module.exports = __webpack_public_path__ + "static/gatsby-fa38ab30a9b8abb4a1ff8c0b7fb86cef.png";